export default __webpack_public_path__ + "static/media/task-line.b5021ba3.svg";